var _defs, _path, _g, _path2;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgDefaultAvatar = function SvgDefaultAvatar(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 252.7"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "default-avatar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m250 252.7-6.9-28.6c-6.9-28.6-45.38-39.4-68.82-48.22s-21.76-23.25-21.76-57.73h-55c0 34.48 1.68 48.9-21.76 57.73S13.8 195.48 6.9 224.1L0 252.7z",
    fill: "#a8b9ca"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m250 252.7-6.9-28.6c-6.9-28.6-45.38-39.4-68.82-48.22s-21.76-23.25-21.76-57.73h-55c0 34.48 1.68 48.9-21.76 57.73S13.8 195.48 6.9 224.1L0 252.7z",
    fill: "#a8b9ca"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default-avatar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.25 19.43C99 19.43 76.37 40.7 76.37 67L82 87.16c0 13.43 10 75.48 43.27 75.48 29 0 43.28-62 43.28-75.48l5.6-20.2c-.02-26.25-21.9-47.53-48.9-47.53z",
    fill: "#8d9aab"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m172.4 83.65 1.22-11.45c0-26.16-22.5-47.38-48.63-47.52C98.86 24.82 76.37 46 76.37 72.2l1.22 11.45c-5.25-.53-10.33 2.34-8 12.82 1.52 6.84 7.8 10.47 10.42 9.9l.48 8.55c0 27.6 32.62 41.23 44.5 41.4 11.9-.18 44.5-13.82 44.5-41.4l.48-8.55c2.6.56 8.9-3.07 10.42-9.9 2.33-10.47-2.75-13.35-8-12.82z",
    fill: "#a8b9ca"
  })));
};

export { SvgDefaultAvatar as ReactComponent };
export default "/_next/static/media/default-avatar.5032cb89.svg";